import React from 'react';
import classNames from 'classnames';
import { ChevronUpIcon, ChevronDownIcon } from 'components/icons';
import styles from './DiagnosticPackageTableHeading.module.css';

function DiagnosticPackageTableHeading({ className, style, children, sortable, toggleSort }) {
  return (
    <div
      role="columnheader"
      tabIndex="-1"
      className={classNames(styles.root, 'rt-th', className)}
      style={style}
      onClick={toggleSort}
    >
      {children}
      {sortable && (
        <div className={styles.sort}>
          <ChevronUpIcon className={classNames(styles.icon, styles.asc)} />
          <ChevronDownIcon className={classNames(styles.icon, styles.desc)} />
        </div>
      )}
    </div>
  );
}

export default DiagnosticPackageTableHeading;
